<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper" :class="{ 'is-collapsed': !advanced }">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="员工姓名">
                  <a-input
                    v-model:value="queryState.nickName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="岗位名称">
                  <a-input
                    v-model:value="queryState.postName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="手环MAC">
                  <a-input
                    v-model:value="queryState.wristbandMac"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <span class="search-actions-group">
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </span>
                </a-form-item>
              </a-col>

              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="员工角色">
                    <a-input
                      v-model:value="queryState.roleName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="民族">
                    <a-input
                      v-model:value="queryState.nationality"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="出生年月日">
                    <a-range-picker
                      v-model:value="birthDateRange"
                      style="width: 100%"
                      format="YYYY-MM-DD"
                      valueFormat="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>

                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="入职日期">
                    <a-range-picker
                      v-model:value="entryTimeRange"
                      style="width: 100%"
                      format="YYYY-MM-DD"
                      valueFormat="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="当前状态">
                    <a-select
                      placeholder="请选择"
                      v-model:value="queryState.userStatus"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option :value="1">正常</a-select-option>
                      <a-select-option :value="0">禁用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="用户手机号">
                    <a-input
                      v-model:value="queryState.phoneNumber"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="用户登录名">
                    <a-input
                      v-model:value="queryState.userName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button"
                        ><SearchOutlined />搜索</a-button
                      >
                      <span class="search-actions-group">
                        <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                        <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                          {{ advanced ? '收起' : '展开' }}
                          <UpOutlined v-if="advanced" />
                          <DownOutlined v-else />
                        </a-button>
                      </span>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="refreshData"
            v-hasPermi="['system:projectUser:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button type="primary" @click="handleAdd" v-hasPermi="['system:projectUser:add']" class="add-button">
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['system:projectUser:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            @click="handleImport"
            v-hasPermi="['system:projectUser:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleEditStatus"
            v-hasPermi="['system:projectUser:status']"
            class="no-border-button edit-status-button"
          >
            <EditOutlined />修改状态
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:projectUser:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
        </div>
        <!-- 组件 -->
        <create-form
          ref="createFormRef"
          :deptOptions="deptOptions"
          :loginPlatformOptions="dictUserAuthorizedPlatform"
          :currentStatusOptions="dictCurrentStatus"
          :sexOptions="dictSysUserSex"
          @ok="getList"
          @close="getList"
        />
        <import-excel ref="importExcelRef" @ok="getList" />

        <!-- <employee-log
          :visible="employeeLogModalVisible"
          :userId="currentUserId"
          :userName="currentUserName"
          permissionPrefix="system:projectUser"
          @close="handleCloseEmployeeLog"
        /> -->

        <EmployeeLog
          v-model:visible="employeeLogModalVisible"
          :userId="currentUserId"
          :userName="currentUserName"
          permissionPrefix="system:projectUser"
          @close="handleCloseEmployeeLog"
        />

        <EditStatusModal
          :visible="statusModalVisible"
          :statusOptions="dictCurrentStatus"
          @confirm="handleConfirmEditStatus"
          @cancel="handleCancelEditStatus"
        />
        <certificate-preview
          :visible="certificatePreviewVisible"
          :certificateUrl="currentCertificateUrl"
          @close="handleCloseCertificatePreview"
        />
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="rowSelection"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 2000 }"
            class="optimized-table"
          >
            <!-- 当前状态：直接显示文字 -->
            <template #userStatus="{ record }">
              <span>{{ getUserStatusText(record.userStatus ?? record.status ?? null) }}</span>
            </template>
            <template #departTime="{ record }">
              <span>{{ formatDate(record.departTime) }}</span>
            </template>
            <!-- 操作列 -->
            <template #operation="{ record }">
              <div v-if="record.id !== 1" class="table-action-buttons">
                <template v-if="record.certificateUrl">
                  <a @click="handlePreviewCertificate(record)" v-hasPermi="['system:projectUser:viewCertificate']">
                    证书
                  </a>
                  <span v-if="record.certificateUrl" class="action-divider">|</span>
                </template>

                <a
                  @click="handleViewEmployeeLog(record)"
                  v-hasPermi="['system:projectUser:employeeLog']"
                  class="employee-log-link"
                >
                  员工日志
                </a>
                <span class="action-divider">|</span>

                <a @click="handleEdit(record)" v-hasPermi="['system:projectUser:edit']" class="edit-link"> 编辑 </a>
                <span class="action-divider" v-hasPermi="['system:projectUser:remove']">|</span>

                <a @click="handleSingleDelete(record)" v-hasPermi="['system:projectUser:remove']" class="delete-link">
                  删除
                </a>
              </div>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryState.pageNum - 1) * queryState.pageSize + 1 }} 到第
              {{ Math.min(queryState.pageNum * queryState.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryState.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryState.pageNum, queryState.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryState.pageNum"
              :total="total"
              :page-size="queryState.pageSize"
              :show-total="() => ''"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryState.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, markRaw } from 'vue'
import { useStore } from 'vuex'
import { message, Modal } from 'ant-design-vue'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  ImportOutlined,
  DownloadOutlined,
  UploadOutlined,
  EditOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
import { pageProjectUser, delUser, deptTreeSelect, editUserStatus } from '@/api/system/user'
import { getDicts } from '@/api/system/dict/data'
import { download } from '@/utils/request'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import EmployeeLog from '../user/modules/EmployeeLog'
import CertificatePreview from '../user/modules/CertificatePreview'
import EditStatusModal from '../user/modules/EditStatusModal'

const store = useStore()

// 字典数据
const dictUserAuthorizedPlatform = ref([])
const dictSysNormalDisable = ref([])
const dictCurrentStatus = ref([])
const dictSysUserSex = ref([])

// 初始化字典
const initDicts = async () => {
  try {
    const dictTypes = ['user_authorized_platform', 'sys_normal_disable', 'current_status', 'sys_user_sex']

    for (const type of dictTypes) {
      try {
        const res = await getDicts(type)
        if (res.data && Array.isArray(res.data)) {
          switch (type) {
            case 'user_authorized_platform':
              dictUserAuthorizedPlatform.value = res.data
              break
            case 'sys_normal_disable':
              dictSysNormalDisable.value = res.data
              break
            case 'current_status':
              dictCurrentStatus.value = res.data
              break
            case 'sys_user_sex':
              dictSysUserSex.value = res.data
              break
          }
        }
      } catch (error) {
        console.warn(`加载字典 ${type} 失败:`, error)
      }
    }
  } catch (error) {
    console.error('初始化字典失败:', error)
  }
}

// 优化表格列配置 - 设置最小宽度防止换行
const tableColumns = markRaw([
  {
    title: '序号',
    dataIndex: 'index',
    align: 'center',
    width: 80,
    customRender: ({ index }) => {
      const { pageNum, pageSize } = queryState
      return (pageNum - 1) * pageSize + index + 1
    },
  },
  {
    title: '员工姓名',
    dataIndex: 'nickName',
    align: 'center',
    width: 120,
    ellipsis: true, // 超出显示省略号
  },
  {
    title: '岗位名称',
    dataIndex: 'postName',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '手环MAC',
    dataIndex: 'wristbandMac',
    align: 'center',
    width: 180, // 设置合理宽度，能够完整展示MAC地址内容（通常17个字符）
    ellipsis: false, // 不省略，完整展示内容
  },
  {
    title: '员工角色',
    dataIndex: 'roleName',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '民族',
    dataIndex: 'nationality',
    align: 'center',
    width: 100,
    ellipsis: true,
  },
  {
    title: '出生年月',
    dataIndex: 'birthDate',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '入职日期',
    dataIndex: 'entryTime',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '离职日期',
    dataIndex: 'departTime',
    align: 'center',
    width: 120,
    ellipsis: true,
    slots: { customRender: 'departTime' },
  },
  {
    title: '当前状态',
    dataIndex: 'userStatus',
    align: 'center',
    width: 100,
    slots: { customRender: 'userStatus' },
  },
  {
    title: '用户手机号',
    dataIndex: 'phoneNumber',
    align: 'center',
    width: 130,
    ellipsis: true,
  },
  {
    title: '用户登录名',
    dataIndex: 'userName',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 200,
    fixed: 'right',
    slots: { customRender: 'operation' },
    align: 'center',
  },
])

// 使用更简单的响应式数据
const advanced = ref(false)
const loading = ref(false)
const list = ref([])
const total = ref(0)
const selectedRowKeys = ref([])
const selectedRows = ref([])

// 分离响应式对象
const queryState = reactive({
  projectId: undefined,
  nickName: undefined,
  postName: undefined,
  wristbandMac: undefined,
  roleName: undefined,
  nationality: undefined,
  birthDateBegin: undefined,
  birthDateEnd: undefined,
  entryTimeBegin: undefined,
  entryTimeEnd: undefined,
  userStatus: undefined,
  phoneNumber: undefined,
  userName: undefined,
  pageNum: 1,
  pageSize: 10,
})

const birthDateRange = computed({
  get() {
    const begin = queryState.birthDateBegin
    const end = queryState.birthDateEnd
    return begin && end ? [begin, end] : []
  },
  set(val) {
    const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
    const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
    queryState.birthDateBegin = begin || undefined
    queryState.birthDateEnd = end || undefined
  },
})

const entryTimeRange = computed({
  get() {
    const begin = queryState.entryTimeBegin
    const end = queryState.entryTimeEnd
    return begin && end ? [begin, end] : []
  },
  set(val) {
    const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
    const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
    queryState.entryTimeBegin = begin || undefined
    queryState.entryTimeEnd = end || undefined
  },
})

// 使用简单的对象作为查询参数
const getQueryParam = () => {
  const currentProjectId = store.getters.currentProjectId
  return {
    projectId: currentProjectId || queryState.projectId,
    nickName: queryState.nickName,
    postName: queryState.postName,
    wristbandMac: queryState.wristbandMac,
    roleName: queryState.roleName,
    nationality: queryState.nationality,
    birthDateBegin: queryState.birthDateBegin,
    birthDateEnd: queryState.birthDateEnd,
    entryTimeBegin: queryState.entryTimeBegin,
    entryTimeEnd: queryState.entryTimeEnd,
    userStatus: queryState.userStatus,
    phoneNumber: queryState.phoneNumber,
    userName: queryState.userName,
    pageNum: queryState.pageNum,
    pageSize: queryState.pageSize,
  }
}

// 计算属性
const multiple = computed(() => selectedRowKeys.value.length === 0)
const ids = computed(() => selectedRows.value.map((item) => item.id))
const submitButtonStyle = computed(() => {
  return {}
})
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: onSelectChange,
  fixed: true,
}))
const tableSize = computed(() => store.state.app.tableSize || 'default')
const tableBordered = computed(() => store.state.app.tableBordered || false)

// 其他响应式数据
const statusModalVisible = ref(false)
const certificatePreviewVisible = ref(false)
const currentCertificateUrl = ref('')
const employeeLogModalVisible = ref(false)
const currentUserId = ref(null)
const currentUserName = ref('')
const deptOptions = ref([])
const createFormRef = ref(null)
const importExcelRef = ref(null)
const jumpPage = ref(1)

const formatDate = (val) => {
  if (val == null || val === '') {
    return ''
  }
  if (typeof val === 'string') {
    return val.length >= 10 ? val.substring(0, 10) : val
  }
  if (Array.isArray(val) && val.length >= 3) {
    const month = String(val[1]).padStart(2, '0')
    const day = String(val[2]).padStart(2, '0')
    return `${val[0]}-${month}-${day}`
  }
  return String(val)
}

const getUserStatusText = (status) => {
  if (status === null || status === undefined || status === '') {
    return '-'
  }
  const statusNum = Number(status)
  if (statusNum === 1) {
    return '正常'
  } else if (statusNum === 0) {
    return '禁用'
  }
  return '-'
}

// 方法

const getTreeselect = () => {}

const getList = async () => {
  try {
    loading.value = true
    const params = getQueryParam()
    const response = await pageProjectUser(params)
    list.value = response.data.records || []
    total.value = response.data.total || 0
    jumpPage.value = queryState.pageNum
  } catch (error) {
    console.error('获取用户列表失败:', error)
    list.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

const handleProjectChanged = (projectId) => {
  queryState.projectId = projectId
  queryState.pageNum = 1
  getList()
}

const getDeptTree = async () => {
  try {
    const response = await deptTreeSelect()
    deptOptions.value = response.data || []
  } catch (error) {
    console.error('获取部门树失败:', error)
    deptOptions.value = []
  }
}

const handleQuery = () => {
  queryState.pageNum = 1
  getList()
}

const refreshData = () => {
  getList()
}

const resetQuery = () => {
  queryState.nickName = undefined
  queryState.postName = undefined
  queryState.wristbandMac = undefined
  queryState.roleName = undefined
  queryState.nationality = undefined
  queryState.birthDateBegin = undefined
  queryState.birthDateEnd = undefined
  queryState.entryTimeBegin = undefined
  queryState.entryTimeEnd = undefined
  queryState.userStatus = undefined
  queryState.phoneNumber = undefined
  queryState.userName = undefined
  queryState.pageNum = 1
  queryState.pageSize = 10

  const currentProjectId = store.getters.currentProjectId
  if (currentProjectId) {
    queryState.projectId = currentProjectId
  }

  handleQuery()
}

const onShowSizeChange = (current, pageSize) => {
  if (loading.value) return

  queryState.pageSize = pageSize
  queryState.pageNum = 1
  jumpPage.value = 1
  getList()
}

const changeSize = (current, pageSize) => {
  if (loading.value) return

  queryState.pageNum = current
  queryState.pageSize = pageSize
  jumpPage.value = current
  getList()
}

const onSelectChange = (keys, rows) => {
  selectedRowKeys.value = keys
  selectedRows.value = rows
}

const toggleAdvanced = () => {
  advanced.value = !advanced.value
}

const handlePreviewCertificate = (record) => {
  if (!record.certificateUrl) {
    message.warning('该用户暂无证书图片', 3)
    return
  }
  currentCertificateUrl.value = record.certificateUrl
  certificatePreviewVisible.value = true
}

const handleCloseCertificatePreview = () => {
  certificatePreviewVisible.value = false
  currentCertificateUrl.value = ''
}

const handleViewEmployeeLog = (record) => {
  console.log('查看员工日志:', record)

  if (!record || !record.id) {
    message.warning('用户信息不完整', 3)
    return
  }

  // 确保先设置数据
  currentUserId.value = record.id
  currentUserName.value = record.nickName || record.userName || '未知用户'

  // 然后打开弹窗
  employeeLogModalVisible.value = true

  console.log('弹窗状态设置为 true')
}

const handleCloseEmployeeLog = () => {
  employeeLogModalVisible.value = false
  currentUserId.value = null
  currentUserName.value = ''
}

const handleAdd = () => {
  console.log('handleAdd 被调用, createFormRef:', createFormRef.value)
  if (!createFormRef.value) {
    console.error('CreateForm组件引用不存在，请检查组件是否正确渲染')
    message.error('表单组件未初始化，请刷新页面重试')
    return
  }
  try {
    console.log('准备调用 createFormRef.value.handleAdd')
    createFormRef.value.handleAdd()
    console.log('handleAdd 调用完成')
  } catch (error) {
    console.error('打开新增弹窗失败:', error)
    message.error('打开新增弹窗失败: ' + error.message)
  }
}

const handleEdit = (record) => {
  createFormRef.value?.handleUpdate(record, undefined)
}

const handleImport = () => {
  importExcelRef.value?.importExcelHandleOpen()
}

const handleEditStatus = () => {
  if (ids.value.length === 0) {
    message.warning('请先选择要修改状态的用户', 3)
    return
  }
  console.log('打开修改状态弹窗，statusModalVisible:', statusModalVisible.value)
  console.log('字典数据:', dictCurrentStatus.value)
  statusModalVisible.value = true
  console.log('设置后 statusModalVisible:', statusModalVisible.value)
}

const handleConfirmEditStatus = async (userStatus) => {
  try {
    const res = await editUserStatus({
      ids: ids.value.join(','),
      userStatus: userStatus,
    })
    if (res.success) {
      message.success('修改状态成功', 3)
      statusModalVisible.value = false
      selectedRowKeys.value = []
      selectedRows.value = []
      getList()
    } else {
      message.error(`修改状态失败: ${res.message}`, 3)
    }
  } catch (error) {
    message.error('修改状态异常', 3)
  }
}

const handleCancelEditStatus = () => {
  statusModalVisible.value = false
}

const handleSingleDelete = (row) => {
  Modal.confirm({
    title: '确认删除?',
    content: `确定要删除员工 "${row.nickName}" 吗?`,
    onOk: async () => {
      try {
        await delUser(row.id)
        message.success('删除成功', 3)
        getList()
        if (selectedRowKeys.value.includes(row.id)) {
          selectedRowKeys.value = selectedRowKeys.value.filter((id) => id !== row.id)
          selectedRows.value = selectedRows.value.filter((item) => item.id !== row.id)
        }
      } catch (error) {
        message.error('删除失败', 3)
      }
    },
  })
}

const handleDelete = () => {
  if (ids.value.length === 0) {
    message.warning('请先选择要删除的用户', 3)
    return
  }

  Modal.confirm({
    title: '确认删除所选中数据?',
    content: `确定要删除 ${ids.value.length} 条数据吗?`,
    onOk: async () => {
      try {
        await delUser(ids.value.join(','))
        message.success('删除成功', 3)
        selectedRowKeys.value = []
        selectedRows.value = []
        getList()
      } catch (error) {
        message.error('删除失败', 3)
      }
    },
  })
}

const handleExport = () => {
  const hasSelection = ids.value.length > 0
  Modal.confirm({
    title: '是否确认导出?',
    content: hasSelection ? `将导出所选 ${ids.value.length} 条数据` : '将导出当前筛选条件下的全部数据',
    onOk: () => {
      const params = getQueryParam()
      if (hasSelection) {
        params.userIds = ids.value
      }
      download('system/user/exportProjectUser', params, `项目用户_${new Date().getTime()}.xlsx`)
    },
  })
}

const handleDownloadTemplate = () => {
  importExcelRef.value?.importTemplate?.()
}

const handleJumpPage = () => {
  if (jumpPage.value && jumpPage.value >= 1) {
    const maxPage = Math.ceil(total.value / queryState.pageSize)
    if (jumpPage.value > maxPage) {
      jumpPage.value = maxPage
    }
    queryState.pageNum = jumpPage.value
    getList()
  }
}

// 生命周期
onMounted(async () => {
  try {
    await initDicts()

    const currentProjectId = store.getters.currentProjectId
    if (currentProjectId) {
      queryState.projectId = currentProjectId
    }

    await Promise.all([getList(), getDeptTree()])
  } catch (error) {
    console.error('ProjectUser 组件初始化失败:', error)
  }
})

// 监听 Vuex 项目变化，切换顶部项目后自动刷新列表
watch(
  () => store.getters.currentProjectId,
  (projectId, prevProjectId) => {
    if (projectId !== prevProjectId) {
      handleProjectChanged(projectId)
    }
  }
)
</script>

<style scoped>
/* 去掉当前页卡片阴影（展开收起按钮底部无阴影） */
:deep(.ant-card) {
  box-shadow: none !important;
}

/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
/* 覆盖所有边框相关属性 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 所有输入框的外层容器（ant-input-affix-wrapper）样式 - allow-clear 时会自动包裹 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 输入框内部的 input 元素 - 必须去掉边框避免嵌套 - 最高优先级 */
/* 使用更具体的选择器确保覆盖所有情况 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 如果没有被 affix-wrapper 包裹的纯 input（理论上很少见，但保留兼容性） */
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input:not(.ant-input-affix-wrapper .ant-input)) {
  width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 强制去掉所有在 affix-wrapper 内的 input 边框 - 使用最高优先级选择器 */
/* 覆盖所有可能的边框属性和状态 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
}

/* 大屏下（宽度 ≥ 1440px），搜索区域所有输入类控件宽度统一缩小 50px */
@media (min-width: 1440px) {
  .table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
  .table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
    width: 170px !important; /* 220 - 50 */
  }

  .table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input:not(.ant-input-affix-wrapper .ant-input)) {
    width: 170px !important;
  }

  .table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
  .table-page-search-wrapper :deep(.ant-picker) {
    width: 170px !important;
    min-width: 170px !important;
    max-width: 170px !important;
  }

  .table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
  .table-page-search-wrapper :deep(.ant-select-selector),
  .table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
  .table-page-search-wrapper :deep(.ant-select) {
    width: 170px !important;
    min-width: 170px !important;
    max-width: 170px !important;
  }
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 导入和导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover,
.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover :deep(.anticon),
.import-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 修改状态按钮样式 - 参照 space 页面下载二维码按钮 */
.edit-status-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.edit-status-button:hover,
.edit-status-button:focus {
  color: #333333 !important;
}

.edit-status-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 员工日志按钮颜色 */
.table-action-buttons .employee-log-link {
  color: #ffa759 !important;
}

.table-action-buttons .employee-log-link:hover {
  color: #ffb877 !important;
}

/* 删除按钮颜色 - 红色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  flex: 0 0 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input:not(.ant-input-affix-wrapper .ant-input)) {
  width: 100% !important;
  max-width: 260px !important;
}

.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector),
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 260px !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper.is-collapsed :deep(.ant-input-affix-wrapper),
.table-page-search-wrapper.is-collapsed
  :deep(.ant-form-item-control-input .ant-input:not(.ant-input-affix-wrapper .ant-input)),
.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper.is-collapsed :deep(.ant-picker),
.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper.is-collapsed :deep(.ant-select-selector),
.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper.is-collapsed :deep(.ant-select) {
  max-width: none !important;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

.table-page-search-submitButtons {
  flex-wrap: wrap;
}

.search-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item) {
    flex-direction: column;
    align-items: stretch;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 全选按钮indeterminate状态：改为蓝色 */
.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner::after) {
  background-color: #ffffff !important;
  border-top-color: #ffffff !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  border-left-color: transparent !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}
</style>
